import { HttpHeaders } from '@angular/common/http';

export const getFilenameFromHeaders = (headers: Headers | HttpHeaders) => {
  const contentDisposition = headers.get('Content-Disposition');
  const matches = contentDisposition?.match(/filename="(.+)"/);

  return matches?.length ? matches[1] : undefined;
};
